import { Component } from "../component"
import { debounce } from "../helpers/debounce"

export class Body extends Component {
  constructor(props) {
    super(props)
  }

  ui() {
    return {}
  }

  initVh() {
    let vh
    const set = (setInitialProperty = false) => {
      vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty("--vh", `${vh}px`)
      if (setInitialProperty) {
        document.documentElement.style.setProperty("--initial-vh", `${vh}px`)
      }
    }

    set(true)

    window.addEventListener("orientationchange", () => {
      setTimeout(() => {
        set(true)
      }, 100)
    })

    window.addEventListener(
      "resize",
      debounce((e) => {
        set()
      })
    )
  }

  created() {
    this.initVh()
  }
}
